import { render, staticRenderFns } from "./medication-treatment-consent-section.vue?vue&type=template&id=79c0bf26&scoped=true"
import script from "./medication-treatment-consent-section.vue?vue&type=script&lang=js"
export * from "./medication-treatment-consent-section.vue?vue&type=script&lang=js"
import style0 from "./medication-treatment-consent-section.vue?vue&type=style&index=0&id=79c0bf26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c0bf26",
  null
  
)

export default component.exports